// extracted by css-extract-rspack-plugin
export default {"container":"s_utL","message":"DxEzw","iframe":"L0aUL"};